import React from 'react';
import ReactDOM from 'react-dom';
import config from 'config/baseUrl';
import App from './App';

config();

ReactDOM.render(<App />, document.getElementById('root'));
